import styled from 'styled-components';

import Text from '~components/Text';

function BlockedInfo() {
  return (
    <Wrapper>
      <img src='https://image.wanted.co.kr/kreditjob/www/lock.png' alt='sad face' />
      <Text typography='bold150_B2'>{'아쉽게도 기업이 공개를 원하지 않습니다.'}</Text>
    </Wrapper>
  );
}

export default BlockedInfo;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 46px auto 40px;

  & > img {
    width: 80px;
    margin-bottom: 13px;
  }
`;
